import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 对于 Bootstrap 4 或更早版本
import 'jquery';
import 'popper.js';
import 'bootstrap';
import store from './store'

import AOS from 'aos';
import 'aos/dist/aos.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import  CKEditor  from 'ckeditor4-vue';
Vue.use(CKEditor)

Vue.use(ElementUI);
// 初始化 aos
AOS.init({
    duration: 700,
    // disable:  ()=> {
    //   var maxWidth = 900;
    //   return window.innerWidth < maxWidth;
    // }
});
Vue.config.productionTip = false
Vue.prototype.$isDevelopment = process.env.NODE_ENV === 'development'

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')